import React, { useEffect } from "react";
import { Download, Clock3, X } from "lucide-react";
import { jsPDF } from "jspdf";
const ContestResultModal = ({
  isOpen,
  onClose,
  result,
  onGoDashboard,
  onDownloadPdf,
  contestData,
  isLoading = false,
  title = "Performance Summary",
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    document.body.classList.add("contest-result-modal-open");

    return () => {
      document.body.classList.remove("contest-result-modal-open");
    };
  }, [isOpen]);

  if (!isOpen) return null;
 
const user = result?.user || {};
const performance = result?.performance || {};
const timeAnalytics = result?.timeAnalytics || {};
const status = result?.status || {};
const leaderboard = result?.leaderboard || [];

const totalQuestions = performance?.totalQuestions || 0;
const rightCount = performance?.correctAnswers || 0;
const wrongCount = performance?.incorrectAnswers || 0;
const skipCount = performance?.skippedAnswers || 0;

const attemptedQuestions =
  performance?.attemptedQuestions ??
  Math.max(totalQuestions - skipCount, 0);

const finalScoreValue = performance?.finalScore || 0;
const accuracyValue = performance?.accuracy || 0;

const earnedCoins = user?.coinsEarned || 0;
const userRank = user?.rank || 0;

const displayName = user?.name || "User";
const displayContestID = user?.UniqueContestId || "--";

const contestName = result?.contestName || contestData?.title || "";
const contestId =
  result?.contestId ||
  contestData?._id ||
  contestData?.contestId ||
  "--";

const avgTimePerQuestion =
  timeAnalytics?.avgTimePerQuestion || 0;

const avgTimeOnCorrect =
  timeAnalytics?.avgTimeOnCorrect || 0;

const totalTimeTaken =
  timeAnalytics?.totalTimeTaken || 0;

const resultDeclareTime =
  contestData?.resultDeclareTime ||
  status?.resultDeclareTime ||
  null;

const submittedAt =timeAnalytics?.submitTime ||0;
console.log(submittedAt,timeAnalytics?.submittedAt,"submit time")
const winningAmount =
  user?.winningAmount ||
  result?.winningAmount ||
  0;


  const initials = displayName
    ?.split(" ")
    .map((word) => word?.[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();


  const scorePercent = Math.min(Math.max(Number(accuracyValue || 0), 0), 100);

  const formatTime = (value) => {
    if (value === null || value === undefined || value === "") return "--";

    if (typeof value === "number") {
      if (value < 60) return `${value}s`;

      const minutes = Math.floor(value / 60);
      const seconds = value % 60;

      return `${minutes}m ${seconds}s`;
    }

    return value;
  };


 const formatSubmitTimeOnly = (value) => {
  if (!value) return "--";

  const date = new Date(value);

  return date.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
const formatSubmitTime = (value) => {
  if (!value) return "--";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
  const statCards = [
    {
      label: "Total Questions",
      value: totalQuestions,
      valueClass: "text-white",
    },
    {
      label: "Correct Answer",
      value: rightCount,
      valueClass: "text-green-400",
    },
    {
      label: "Incorrect Answer",
      value: wrongCount,
      valueClass: "text-red-400",
    },
    {
      label: "Attempted Questions",
      value: attemptedQuestions,
      valueClass: "text-white",
    },
  ];

  const getSafeFileName = (value) =>
    String(value || "contest-summary")
      .trim()
      .replace(/[^a-z0-9]+/gi, "-")
      .replace(/^-+|-+$/g, "")
      .toLowerCase();

  const handleDownloadPdf = () => {
    // if (onDownloadPdf) {
    //   onDownloadPdf(result);
    //   return;
    // }

    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 44;
    let y = 54;

    doc.setFillColor(75, 35, 102);
    doc.rect(0, 0, pageWidth, 110, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.text(title, pageWidth / 2, y, { align: "center" });

    y += 38;
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Name: ${displayName}`, margin, y);
    doc.text(`Contest ID: ${displayContestID || "--"}`, margin, y + 18);

    y = 150;
    doc.setTextColor(35, 31, 38);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Score Summary", margin, y);

    y += 28;
    const rows = [
      [
        "Final Score",
        Number(finalScoreValue || 0).toFixed(
          Number(finalScoreValue || 0) % 1 === 0 ? 0 : 2,
        ),
      ],
      ["Accuracy", `${accuracyValue}%`],
      ["Total Questions", totalQuestions],
      ["Correct Answer", rightCount],
      ["Incorrect Answer", wrongCount],
      ["Attempted Questions", attemptedQuestions],
      ["Skipped Questions", skipCount],
    ];

    doc.setFontSize(12);
    rows.forEach(([label, value], index) => {
      const rowY = y + index * 28;
      doc.setFillColor(
        index % 2 === 0 ? 247 : 255,
        index % 2 === 0 ? 244 : 255,
        index % 2 === 0 ? 250 : 255,
      );
      doc.rect(margin, rowY - 17, pageWidth - margin * 2, 24, "F");
      doc.setFont("helvetica", "bold");
      doc.text(String(label), margin + 12, rowY);
      doc.setFont("helvetica", "normal");
      doc.text(String(value ?? "--"), pageWidth - margin - 12, rowY, {
        align: "right",
      });
    });

    y += rows.length * 28 + 24;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Time Analytics", margin, y);

    y += 28;
    const timeRows = [
      ["Result Declare Time", formatTime(resultDeclareTime)],
      ["Average / Question", formatTime(avgTimePerQuestion || totalTimeTaken)],
      [
        "Average On Correct",
        formatTime(avgTimeOnCorrect || avgTimePerQuestion),
      ],
      ["Submitted At", formatSubmitTimeOnly(submittedAt)],
    ];

    doc.setFontSize(12);
    timeRows.forEach(([label, value], index) => {
      const rowY = y + index * 28;
      doc.setFillColor(
        index % 2 === 0 ? 247 : 255,
        index % 2 === 0 ? 244 : 255,
        index % 2 === 0 ? 250 : 255,
      );
      doc.rect(margin, rowY - 17, pageWidth - margin * 2, 24, "F");
      doc.setFont("helvetica", "bold");
      doc.text(String(label), margin + 12, rowY);
      doc.setFont("helvetica", "normal");
      doc.text(String(value ?? "--"), pageWidth - margin - 12, rowY, {
        align: "right",
      });
    });

    doc.setTextColor(120, 120, 120);
    doc.setFontSize(10);
    doc.text("Generated by Adhyayi", margin, 805);

    doc.save(
      `${getSafeFileName(displayName)}-${getSafeFileName(displayContestID || "--")}-summary.pdf`,
    );
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/55 px-3 py-2 backdrop-blur-sm sm:pt-20">
      <div className="relative max-h-[94vh] w-full max-w-[420px] overflow-y-auto rounded-[34px] border-2 border-[#A875FF] bg-[#4B2366] px-5 py-2 text-white shadow-[0_22px_60px_rgba(0,0,0,0.45)] sm:max-w-[460px] sm:px-7 lg:max-h-[90vh] lg:max-w-[900px] lg:px-8">
        {/* Close */}
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20"
        >
          <X size={18} />
        </button>

        {/* Title */}
        <h2 className="text-center sm:pb-0 text-md font-bold tracking-wide sm:text-lg">
          {title}
        </h2>

        {!result ? (
          <div className="mt-8 rounded-2xl bg-white/10 px-4 py-10 text-center text-sm font-semibold text-white/80">
            Loading summary...
          </div>
        ) : (
          <>
            <div className="lg:mt-5 lg:grid lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-start lg:gap-4">
              <div>
                {/* User Card */}
                <div className="mt-5 flex items-center gap-4 rounded-2xl bg-white/10 px-4 py-2 lg:mt-0">
                  <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#9274D7] text-2xl font-extrabold text-white">
                    {initials || "U"}
                  </div>

                  <div className="min-w-0 text-left">
                    <h3 className="truncate text-xl font-bold text-[#F5A623] sm:text-xl">
                      {displayName}
                    </h3>

                    <p className="mt-1 truncate text-sm text-white/70">
                      Contest ID : {displayContestID || "--"}
                    </p>

                    {contestName && (
                      <p className="mt-0 truncate text-sm text-white/70">
                        {contestName}
                      </p>
                    )}
                  </div>
                </div>

                {/* Score Circle */}
                <div className="mt-4 flex justify-center">
                  <div
                    className="relative flex h-20 w-20 items-center justify-center rounded-full"
                    style={{
                      background: `conic-gradient(#F5A623 ${scorePercent * 3.6}deg, #B39DD4 0deg)`,
                    }}
                  >
                    <div className="flex h-[60px] w-[60px] flex-col items-center justify-center rounded-full bg-[#4B2366]">
                      <p className="text-xl font-bold text-[#F5A623]">
                        {Number(finalScoreValue || 0).toFixed(
                          Number(finalScoreValue || 0) % 1 === 0 ? 0 : 2,
                        )}
                      </p>
                      <p className="text-sm text-white">Final Score</p>
                    </div>
                  </div>
                </div>

                {/* Stats */}
                <div className="mt-4 grid grid-cols-4 gap-2 sm:grid-cols-4 sm:gap-2">
                  {statCards.map((item) => (
                    <div
                      key={item.label}
                      className="flex flex-col items-center justify-center rounded-xl border border-[#C9A45E] px-2 py-2 text-center"
                    >
                      <p className="text-[12px] leading-5 text-white/85 sm:text-sm">
                        {item.label}
                      </p>

                      <p
                        className={`mt-2 text-lg font-bold ${item.valueClass}`}
                      >
                        {item.value}
                      </p>
                    </div>
                  ))}
                </div>

                {/* {Boolean(userRank || earnedCoins || winningAmount) && (
                  <div className="mt-2 grid grid-cols-2 gap-3">
                    <div className="rounded-2xl bg-white/10 px-4 py-2 text-center">
                      <p className="text-sm text-white/70">Rank</p>
                      <p className="mt-2 text-2xl font-extrabold text-[#F5A623]">
                        {userRank ? `#${userRank}` : "--"}
                      </p>
                    </div>

                    <div className="rounded-2xl bg-white/10 px-4 py-2 text-center">
                      <p className="text-sm text-white/70">Reward</p>
                      <p className="mt-2 text-xl font-extrabold text-[#F5A623]">
                        {earnedCoins || winningAmount || 0}
                      </p>
                    </div>
                  </div>
                )} */}
              </div>

              <div className="lg:min-w-0">
                {/* Accuracy */}
                <div className="mt-6 lg:mt-0">
                  <div className="flex items-center justify-between gap-3">
                    <span className="rounded-lg bg-[#F5A623] px-5 py-2 text-sm font-bold text-white">
                      {accuracyValue >= 80
                        ? "Excellent"
                        : accuracyValue >= 50
                          ? "Good"
                          : "Keep Trying"}
                    </span>

                    <p className="text-md sm:text-xl">
                      Accuracy: {accuracyValue}%
                    </p>
                  </div>

                  <div className="mt-2 h-2 overflow-hidden rounded-full bg-white/25">
                    <div
                      className="h-full rounded-full bg-[#F5A623]"
                      style={{ width: `${scorePercent}%` }}
                    />
                  </div>
                </div>

                {/* Time Analytics */}
                <div className="mt-2 rounded-2xl bg-white/10 px-4 py-5">
                  <h3 className="text-left text-md font-bold">
                    Time Analytics
                  </h3>

                  <div className="mt-2 rounded-2xl bg-white/10 px-4 py-2">
                    <div className="flex items-center justify-between">
                      <div className="text-left">
                        <p className="text-sm text-white/70">
                          Result Declare Time
                        </p>
                        <p className="mt-1 text-md">
                          {formatSubmitTime(resultDeclareTime)}
                        </p>
                      </div>

                      <Clock3 className="text-[#F5A623]" size={25} />
                    </div>
                  </div>

                  <div className="mt-4 grid grid-cols-3 gap-3">
                    <div className="rounded-2xl bg-white/10 px-2 py-2 text-center">
                      <p className="text-sm text-white/70">Avg / Que</p>
                      <p className="mt-3 text-md">
                        {formatTime(avgTimePerQuestion || totalTimeTaken)}
                      </p>
                    </div>

                    <div className="rounded-2xl bg-white/10 px-2 py-4 text-center">
                      <p className="text-sm text-white/70">On Correct</p>
                      <p className="mt-3 text-md font-bold">
                        {formatTime(avgTimeOnCorrect || avgTimePerQuestion)}
                      </p>
                    </div>

                    <div className="rounded-2xl bg-white/10 px-2 py-4 text-center">
                      <p className="text-sm text-white/70">Submit</p>
                      <p className="mt-3 text-md font-bold">
                        {formatSubmitTimeOnly(submittedAt)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Download PDF */}
                <button
                  type="button"
                  onClick={handleDownloadPdf}
                  className="mt-4 w-full items-center gap-2 rounded-2xl border border-white/20 px-5 py-2 text-left hover:bg-white/10 flex"
                >
                  <Download size={20} />

                  <div>
                    <p className="text-md font-semibold">Download PDF</p>
                    <p className="text-sm text-white/65">
                      Adjusted size with summary details
                    </p>
                  </div>
                </button>

                {/* Bottom Button */}
                <button
                  type="button"
                  onClick={onGoDashboard}
                  className="mt-6 w-full rounded-full bg-[#F5A623] px-6 py-4 text-lg font-extrabold tracking-wide text-white shadow-lg lg:block"
                >
                  Play More Contest
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ContestResultModal;
